import {StyledTextError} from './index.styled'
 import {CgDanger} from "react-icons/cg"
function TextError(props) {
  return <StyledTextError>
    <CgDanger/>
    {props.children}
  </StyledTextError>;
}

export default TextError;
